// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"77ea804e","263":"0039c842","517":"d33c62f6","575":"464b5e05","839":"f2ff592e","993":"402ac102"}[chunkId] + ".chunk.js";
};